export default {
	data () {
	  return {
      formatter: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      })
	  }
	},
	methods: {
    formatBalance(value) {
      var doubleValue = value * .01
      return this.formatter.format(doubleValue)
    },
    formatDouble(value) {
      return this.formatter.format(value)
    }
	}
}